export const serverUri = 'https://topentol.sirv.com/jssummit';

export default {};
